import { PageHero } from "../components/layout/PageHero";

export function CheckoutPreparingPage() {
  return (
    <PageHero
      eyebrow="Checkout Beauty"
      title="Checkout com 7 dias grátis em preparação."
      text="O fluxo oficial será: escolher plano, criar conta, informar cartão ou Pix automático, liberar o espaço Beauty e iniciar a cobrança somente no dia 8 se não houver cancelamento."
      primary={{ href: "/go/pricing", label: "Ver planos" }}
      secondary={{ href: "/beauty", label: "Voltar para Beauty" }}
    />
  );
}
